import { getReduxStore } from '../store-reference.js';
import { getUserSchema } from './selectors.js';
import { useWorkingCopyStore } from './store/working-copy-store.js';

/**
 * Static getter for the active schema. In React, use `useActiveSchema()` instead.
 * This is intended to be replaced when schema storage is reunited in Zustand.
 */
export const getActiveSchema = () => {
  const workingCopyJSON = useWorkingCopyStore.getState().workingCopyJSON;
  const currentBranchJSON = getUserSchema(getReduxStore().getState());
  return workingCopyJSON ?? currentBranchJSON;
};
